import { render, staticRenderFns } from "./qsreports.vue?vue&type=template&id=9871e102&scoped=true"
import script from "./qsreports.vue?vue&type=script&lang=js"
export * from "./qsreports.vue?vue&type=script&lang=js"
import style0 from "./qsreports.vue?vue&type=style&index=0&id=9871e102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9871e102",
  null
  
)

export default component.exports